'use client';
import { useTranslation } from '@/i18n/client';
import style from './index.module.scss';

function Index() {
  const { t } = useTranslation();
  return (
    <div className={style.empty_container}>
      <img src='https://st.joy-sourcing.com/website/other/empty-box.png' alt='empty' />
      {t('cms.ukH5ProductActivity.emptyText')}
    </div>
  );
}

export default Index;
